module.exports = "/assets/data/2c975b501094869196491a9de15537eb-UB5.data.json";